import { gql } from '@apollo/client'
import type { Order } from '@ztechapps/common.contract'
import { useSubscription, type UseSubscriptionProps } from '@ztechapps/common.hook'
import { purchaseOrderFragment, singlePurchaseOrderQuery } from './graphql'

const defaultQuery = gql`
  ${purchaseOrderFragment}
  subscription updatedPurchaseOrder($filter: JSON) {
    updatedPurchaseOrder(filter: $filter) {
      ...purchaseOrderFragment
    }
  }
`

export type UsePurchaseOrderUpdatedSubscriptionProps = {
  purchaseOrderId: string
} & UseSubscriptionProps<{ updatedOrder: Order }>

export const usePurchaseOrderUpdatedSubscription = ({
  query,
  purchaseOrderId,
  filter,
  ...props
}: UsePurchaseOrderUpdatedSubscriptionProps) => {
  query ??= defaultQuery
  filter ??= {
    _id: purchaseOrderId,
  }

  return useSubscription<{ updatedOrder: Order }>({
    query,
    filter,
    cacheQuery: singlePurchaseOrderQuery,
    entityName: 'purchaseOrder',
    ...props,
  })
}
